<template>
  <div class="new-store-info" :style="{'padding': isUggSell ? '10px' : '20px 15px 23px 20px'}">
    <div class="store">
      <img class="storImg" :src="$viewImage(businessInfo && businessInfo.store && businessInfo.store.icon)" alt="">
      <div class="store-msg">
        <div class="storeModal" v-show="showStoreModal" @mouseleave="mouseleave">
          <div class="store">
            <span class="storeName">{{businessInfo && businessInfo.business && businessInfo.business.shopName}}</span>
            <img :src="super_store_flag == 1 ? require('@/assets/images/good_store_red.png') : require('@/assets/images/good_store_dust.png')" alt="">
          </div>
          <div class="business">商家名称：<span>{{businessInfo && businessInfo.business && businessInfo.business.fullName}}</span></div>
          <div class="line"></div>
          <div class="rate">
            <span>动态评分：</span>
            <div class="rate-detail">
              <div v-for="(rItem, rIndex) in dsrRate" :key="'R' + rIndex">
                <span>{{rItem.name}}</span>
                <span>{{rItem.score}}</span>
                <span :style="{color: rItem.level == '低' ? '#00C414' : rItem.level == '中' ? '#FF9C00' : '#FF3A00'}">{{rItem.level}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="msg-top">
          <div class="storeTip">
            <span class="storeName" @mouseenter="mouseenter">{{businessInfo && businessInfo.business && businessInfo.business.shopName}}</span>
            <img v-if="!isUggSell" class="starImg" :src="super_store_flag == 1 ? require('@/assets/images/red_star.png') : require('@/assets/images/dust_star.png')" alt="">
          </div>
          <!-- <span v-if="!isUggSell" @click="openGoodStore" class="goodStore" :style="{color: super_store_flag == 1 ? '#00C414' : '#666666'}">{{ super_store_flag == 1 ? '好店认证通过' : '好店认证未通过'}}></span> -->
        </div>
        <div class="msg-bottom">
          <span class="busName">商家ID：<label class="busVal">{{businessInfo && businessInfo.business && businessInfo.business.id}}</label></span>
          <span class="busName">合同剩余：<label class="busVal">{{businessInfo && businessInfo && businessInfo.contractValidate}}天</label></span>
          <span class="busName" v-if="!isUggSell">违规扣分：<label class="busVal">{{remind.commonBillScore ? remind.commonBillScore : 0}}</label></span>
          <div class="key-btn" v-if="isUggSell">
            <span><show-appkey></show-appkey></span>
            <span @click="openApi">API文档</span>
            <span v-if="!expiresStatus" class="expires-time">{{expiresTime}}</span>
            <span v-if="expiresStatus" class="expires-time-red">{{expiresTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="key-btn-container" v-if="!isUggSell">
      <span><show-appkey></show-appkey></span>
      <span @click="openApi">API文档</span>
        <span v-if="!expiresStatus" class="expires-time">{{expiresTime}}</span>
        <span v-if="expiresStatus" class="expires-time-red">{{expiresTime}}</span>
    </div>
    <div class="growth-part" v-if="!isUggSell">
      <div class="grow-top">
        <div>成长力排名率:<span class="grow-value">{{(storeStarInfo && storeStarInfo.rank_rate) ? (storeStarInfo.rank_rate*100).toFixed(2) : 0}}%</span></div>
        <div class="storeStar">店铺星级：<RateStar :starValue="star_level"/></div>
      </div>
      <div class="axis">
        <template v-for="(v, index) in axisLine">
          <span class="line" :style="{left: (v/100*100) + '%' }" :key='"L" + index'></span>
          <span class="value" :style="{left: (v/100*100 - 1.5) + '%' }" :key='"V" + index'>{{v}}%</span>
        </template>
        <a-tooltip placement="bottomRight">
          <template slot="title">
            <div class="grow-tip">
              <div>本店水平：{{(storeStarInfo && storeStarInfo.rank_rate) ? (storeStarInfo.rank_rate*100).toFixed(2) : 0}}%</div>
              <div>相比昨日：<span :style="{color: (storeStarInfo && storeStarInfo.score_growth_rate)
                ? storeStarInfo.score_growth_rate > 0 ? '#00C414' : '#F43A03' : '' }">{{(storeStarInfo && storeStarInfo.score_growth_rate) ? (Math.abs(storeStarInfo.score_growth_rate)*100).toFixed(2) : 0}}%</span>
                <img :src="(storeStarInfo && storeStarInfo.score_growth_rate) ?
                  storeStarInfo.score_growth_rate > 0 ?
                    require('@/assets/images/grow-up.png') : require('@/assets/images/grow-down.png')
                      : ''" alt=""> </div>
              <div>店铺星级：{{star_level}}星</div>
            </div>
          </template>
          <div class="grow-axis" :style="{width: ((storeStarInfo && storeStarInfo.rank_rate) ? storeStarInfo.rank_rate*100 : 0) + '%', borderRadius: storeStarInfo.rank_rate == 1 ? '5px' : '5px 0px 0px 5px'}"></div>
        </a-tooltip>
      </div>
    </div>
    <div class="honour" v-if="!isUggSell">
      <div class="honour-title">
        <div class="info">
          <span class="title">荣耀时刻</span>
          <span class="honour-date" v-if="honourTimeInfo.isExistHonour">{{honourTimeInfo.selectionCycle}}</span>
        </div>
        <a-button type='link' v-if="honourTimeInfo.isExistHonour && cmsConfig.honourImg.activity_show" @click="openModal('activity_show')">活动说明</a-button>
      </div>
      <div class="honour-detail">
        <div class="honour-img">
          <template v-if="honourTimeInfo.isExistHonour && honourTimeInfo.honour">
            <img src="@/assets/images/honour.png" alt="">
            <span>{{honourTimeInfo.honour.honourName}}</span>
          </template>
          <template v-else-if="honourTimeInfo.isExistHonour && !honourTimeInfo.honour">
            <img src="@/assets/images/no_honour.png" alt="">
          </template>
          <template v-else-if="!honourTimeInfo.isExistHonour">
            <img src="@/assets/images/no_honour_activity.png" alt="">
          </template>
        </div>
        <div class="honour-msg">
          <div v-if="honourTimeInfo.isExistHonour && honourTimeInfo.honour" class="text">本店铺在<span class="rank">“{{honourTimeInfo.honour.rankingListName}}”</span>排行榜中位列第{{honourTimeInfo.honour.ranking}}名，荣获<span class="name">“{{honourTimeInfo.honour.honourName}}”</span>称号</div>
          <div v-else-if="honourTimeInfo.isExistHonour && !honourTimeInfo.honour" class="text">本店铺未在本期荣耀时刻评选中脱颖而出，还要继续加油呀！</div>
          <div v-else-if="!honourTimeInfo.isExistHonour" class="text">暂无荣耀时刻评选活动，敬请期待~</div>
          <div class="honor-btn">
            <a-button type='link' v-if="honourTimeInfo.honour"><HonourCert /></a-button>
            <a-button type='link' v-if="honourTimeInfo.isExistHonour && cmsConfig.honourImg.award_detail" @click="openModal('award_detail')">获奖明细</a-button>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="honourViible" :footer="null" :width='820'>
      <div class="modalContent">
        <img :src="honourImg" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Rate, Button, Tooltip, Modal } from 'ant-design-vue'
import { mapActions, mapState } from 'vuex'
import ShowAppKey from '@/views/home/common/show-appkey'
import HonourCert from '../honour-certificate'
import RateStar from '@/components/rate-star'
export default {
  data() {
    return {
      axisLine:[
        3, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100
      ],
      growAxis:'58.21',
      honourName:'',
      showStoreModal:false,
      honourViible: false,
      honourImg: ''
    }
  },
  components: {
    [Rate.name]: Rate,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [ShowAppKey.name]: ShowAppKey,
    HonourCert,
    [Modal.name]: Modal,
    RateStar
  },
  async created() {
    await this.getKeyExpiresTime()
    await this.querySuperStore()
    await this.queryStarLevel()
  },
  computed:{
    ...mapState(['cmsConfig', 'businessInfo', 'isUggSell']),
    ...mapState('popHome',['honourTimeInfo', 'storeStarInfo', 'super_store_flag', 'dsrRate', 'remind', 'expiresTime', 'expiresStatus']),
    star_level () {
      return (this.storeStarInfo && this.storeStarInfo.star_level) ? 
      this.storeStarInfo.star_level > 4.9 ? 4.9 : this.storeStarInfo.star_level < 2.5 ? 2.5 : this.storeStarInfo.star_level : 2.5
    }
  },
  methods:{
    ...mapActions('popHome',[
      'queryStarLevel', 'querySuperStore', 'getKeyExpiresTime'
    ]),
    mouseenter() {
      if (this.isUggSell) {
        return 
      } 
      this.showStoreModal = true
    },
    mouseleave () {
      this.showStoreModal = false
    },
    openApi () {
      window.open(this.cmsConfig.apiUrl)
    },
    openModal (type) {
      this.honourImg = this.cmsConfig.honourImg[type]
      this.honourViible = true
      // 设置滚动条回到顶部
      this.$nextTick(() => {
        document.getElementsByClassName('modalContent')[0].scrollTop = 0
      })
    },
    // 打开王牌好店
    openGoodStore() {
      window.open(`${process.env.VUE_APP_SEVERENV == 'BETA' ? 'http' : 'https'}://open.haiziwang.com/platform/?link=https%3A%2F%2Fshop.haiziwang.com%2Fstorestar/2`,)
    }
  }
}
</script>

<style lang="scss" scoped>
.new-store-info {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .store {
    display: flex;
    align-items: center;
    .storImg {
      width: 56px;
      height: 56px;
      margin-right: 10px;
    }
    .store-msg {
      display: flex;
      flex: 1;
      flex-direction: column;
      position: relative;
      .msg-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .storeTip {
          display: flex;
          align-items: center;
          .starImg {
            width: 22px;
            height: 22px;
          }
          .storeName {
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 21px;
          }
        }
        .goodStore {
          font-family: MicrosoftYaHei;
          font-size: 13px;
          cursor: pointer;
        }
      }
      .msg-bottom {
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei;
        font-size: 13px;
        line-height: 17px;
        .busName {
          color: #666666;
          .busVal {
            color: #333333;
          }
       
        }
        .key-btn {
          color: #1C7AE5;
          span {
            cursor: pointer;
          }
          .expires-time {
            color: #333333;
          }
           .expires-time-red {
              color: #FF6770;
            }
        }
        span:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }
  .growth-part {
    // margin-top: 14px;
    height: 120px;
    width: 100%;
    background: #F7F7F7;
    padding: 18px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .grow-top {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
      font-family: MicrosoftYaHei;
      font-size: 13px;
      color: #666666;
      .storeStar {
        display: flex;
        align-items: center;
        .ant-rate {
          margin-top: -5px!important;
        }
      }
      .grow-value {
        margin-left: 8px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 14px;
        color: #333333;
        line-height: 19px;
        font-weight: bold;
      }
    }
    .axis {
      margin-top: 20px;
      width: 90%;
      height: 10px;
      background: #D8D8D8;
      border-radius: 5px;
      position: relative;
      .line {
        position: absolute;
        top: 0;
        width: 1px;
        height: 10px;
        background: #F7F7F7;
        z-index: 10;
      }
      .value {
        top: 14px;
        position: absolute;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #666666;
      }
      .grow-axis {
        position: absolute;
        height: 10px;
        background: #1C7AE5;
      }
    }
  }
  .honour {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .honour-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .info {
        display: flex;
        align-items: center;
        .title {
          font-family: MicrosoftYaHei-Bold;
          font-size: 14px;
          color: #333333;
          line-height: 19px;
          font-weight: bold;
          margin-right: 10px;
        }
        .honour-date {
          font-family: MicrosoftYaHei;
          font-size: 13px;
          color: #666666;
        }
      }
    }
    .honour-detail {
      width: 100%;
      margin-top:23px;
      display: flex;
      align-items: center;
      .honour-img {
        margin-right: 20px;
        width: 140px;
        height: 120px;
        flex-shrink: 0;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 75px;
          left: 38px;
          font-family: MicrosoftYaHei-Bold;
          font-size: 16px;
          color: #FFFFFF;
          font-weight: bold;
          text-shadow: 0 1px 4px #2C84E8;
        }
      }
      .honour-msg {
        display: flex;
        flex-direction: column;
        .text {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #333333;
          line-height: 24px;
          .rank {
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: #151515;
          }
          .name {
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: #EE6723;
          }
        }
        .honor-btn {
          display:flex;
          margin-top: 10px;
        }
      }
    }
  }
}

.grow-tip {
  display: flex;
  flex-direction: column;
  font-family: MicrosoftYaHei;
  font-size: 13px;
  color: #FFFFFF;
  line-height: 18px;
  div {
    margin-top: 8px;
    display: flex;
    align-items: center;
  }
  div:first-child {
    margin-top: 0!important;
  }
  img {
    width: 6px;
    height: 12px;
    margin-left: 4px;
  }
}

.storeModal {
  background: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.13);
  padding: 16px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  font-family: MicrosoftYaHei;
  font-size: 13px;
  color: #666666;
  position: absolute;
  z-index: 20;
  .store {
    display: flex;
    align-items: center;
    .storeName {
      font-family: MicrosoftYaHei-Bold;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
    }
    img {
      width: 80px;
      height: 22px;
      margin-left: 4px;
    }
  }
  .business {
    margin-top: 20px;
    display: flex;
    align-items: center;
    line-height: 17px;
    span {
      color: #333333;
    }
  }
  .line {
    width: 200px;
    height: 1px;
    border: 1px dotted #eeeeee;
    margin: 10px 0px 10px 0px
  }
  .rate {
    display: flex;
    .rate-detail {
      display: flex;
      flex-direction: column;
      div {
        color: #333333;
        margin-bottom: 6px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  .btn {
    margin-top: 14px;
    margin-left: 25px;
    font-size: 12px;
    color: #1C7AE5;
    span {
      padding: 4px 12.5px;
      width: 70px;
      height: 24px;
      border: 1px solid #1C7AE5;
      border-radius: 12px;
      cursor: pointer;
    }
    span:first-child {
      margin-right: 10px;
    }
  }
}

.modalContent {
  margin-top: 20px;
  height: 80vh;
  overflow-y: auto;
}
.modalContent::-webkit-scrollbar {
    width: 6px;
  }
  .modalContent::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #C3C3C3;
  }
  .modalContent::-webkit-scrollbar-track {
    border-radius: 6px;
    background: #f0f0f0;
  }
.key-btn-container {
  margin-left: 66px;
  a, span {
    color: #1C7AE5;
    cursor: pointer;
    margin-right: 20px;
  }
   .expires-time {
      color: #333333;
    }
    .expires-time-red {
        color: #FF6770;
      }

}
</style>
